import { generateId } from '@freelancer/datastore/testing';
import { DepositMethodApi } from 'api-typings/payments/payments';
import { CurrencyCode, generateCurrencyObject } from '../currencies';
import {
  BillingAgreement,
  CreditCard,
  Paypal,
  VirtualPaymentMethod,
} from './billing-agreements.model';

export const CREDIT_CARD_NUMBER = '111111****2222';
export const TEAM_BILLING_NAME = 'Team Billing Agreement Name';
export const ENTERPRISE_BILLING_NAME = 'Enterprise Billing Agreement Name';

export interface GenerateBillingAgreementOptions {
  readonly currencyCode?: CurrencyCode;
  readonly token?: string;
  readonly depositMethod: DepositMethodApi;
  readonly lastSuccessTimestamp?: number;

  // for fake credit card
  readonly creditCard?: CreditCard;

  // for fake paypal account
  readonly paypal?: Paypal;

  // for fake virtual payment method
  readonly virtualPaymentMethod?: VirtualPaymentMethod;
}

export function generateBillingAgreementObject({
  currencyCode = CurrencyCode.USD,
  depositMethod,
  lastSuccessTimestamp = Date.now(),
  creditCard,
  paypal,
  virtualPaymentMethod,
}: GenerateBillingAgreementOptions): BillingAgreement {
  return {
    id: generateId().toString(),
    currencyId: generateCurrencyObject(currencyCode).id,
    token: generateId().toString(),
    depositMethod,
    lastSuccessTimestamp,
    creditCard,
    paypal,
    virtualPaymentMethod,
  };
}

export function generateCreditCard({
  creditCardNumber = CREDIT_CARD_NUMBER,
  cardType = 'visa',
}: {
  readonly creditCardNumber?: string;
  readonly cardType?: string;
} = {}): Pick<GenerateBillingAgreementOptions, 'creditCard'> {
  return {
    creditCard: {
      creditCardNumber,
      cardType,
    },
  };
}

export function generateTeamBilling(
  name = TEAM_BILLING_NAME,
): Pick<
  GenerateBillingAgreementOptions,
  'virtualPaymentMethod' | 'depositMethod'
> {
  return {
    depositMethod: DepositMethodApi.TEAM_BILLING,
    virtualPaymentMethod: {
      name,
    },
  };
}

export function generateEnterpriseBilling(
  name = ENTERPRISE_BILLING_NAME,
): Pick<
  GenerateBillingAgreementOptions,
  'virtualPaymentMethod' | 'depositMethod'
> {
  return {
    depositMethod: DepositMethodApi.ENTERPRISE_BILLING,
    virtualPaymentMethod: {
      name,
    },
  };
}
